import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';

interface RoomImageGalleryProps {
  images: string[];
  thumbnailSize?: 'medium' | 'large';
}

const RoomImageGallery: React.FC<RoomImageGalleryProps> = ({ images }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const galleryImages = images && images.length > 0 ? images : ["/no-photo.png"];

  return (
    <>
      {/* Thumbnail Display */}
      <div
        className="relative min-w-[128px] min-h-[96px] max-w-[128px] max-h-[96px] w-[128px] h-[96px] rounded-md overflow-hidden border mr-4 shrink-0"
        onClick={() => openModal(0)}
      >
        <img
          src={
            galleryImages[0]
              ? galleryImages[0].replace("{size}", "120x120")
              : "/no-photo.png"
          }
          alt="Room"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform"
        />
        <div className="absolute bottom-1 left-1 bg-white bg-opacity-80 px-2 py-0.5 text-xs rounded shadow text-gray-700 font-medium">
          {galleryImages.length} photos
        </div>
      </div>

      {/* Modal Gallery */}
      <Dialog open={isOpen} onClose={closeModal} className="fixed z-50 inset-0">
        <div className="bg-black/70 fixed inset-0" aria-hidden="true" />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Dialog.Panel className="relative bg-white rounded-lg max-w-4xl w-full overflow-hidden shadow-lg">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 bg-black/70 p-1.5 rounded-full hover:bg-black transition z-10"
            >
              <X className="w-5 h-5 text-white" />
            </button>

            <div className="relative w-full bg-black flex items-center justify-center">
              <img
                src={
                  galleryImages[currentIndex]?.replace("{size}", "1024x768") ??
                  ""
                }
                alt={`Room ${currentIndex + 1}`}
                className="object-contain w-full max-h-[80vh]"
              />
            </div>

            {/* Navigation Controls */}
            <div className="flex justify-between p-4 items-center bg-white">
              <button
                className="text-sm text-halo-pink font-semibold"
                onClick={() =>
                  setCurrentIndex(
                    (currentIndex - 1 + galleryImages.length) %
                      galleryImages.length
                  )
                }
              >
                ← Prev
              </button>
              <span className="text-sm text-gray-600">
                {currentIndex + 1} / {galleryImages.length}
              </span>
              <button
                className="text-sm text-halo-pink font-semibold"
                onClick={() =>
                  setCurrentIndex((currentIndex + 1) % galleryImages.length)
                }
              >
                Next →
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default RoomImageGallery;